"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseType = void 0;
exports.BaseType = {
    BaseTypeUnspecified: "BASE_TYPE_UNSPECIFIED",
    BaseTypeGenerative: "BASE_TYPE_GENERATIVE",
    BaseTypeClassification: "BASE_TYPE_CLASSIFICATION",
    BaseTypeRerank: "BASE_TYPE_RERANK",
    BaseTypeChat: "BASE_TYPE_CHAT",
};
